// Lightning-Snapshot fuer /zuhause/wetter/blitze. Backend haelt die
// letzten 500 Strikes im Speicher (Track-Radius). Polling 30 s, aber nur
// solange die Seite offen ist (beobachteLightning, lib/bei-bedarf.ts);
// start* spielt nur den SWR-Cache ein. Nach Settings-Update (PATCH
// /lightning/config) ruft die Page refreshLightningSummary() für
// Sofort-Reload.

import { untrack } from "svelte";
import { SvelteMap } from "svelte/reactivity";
import { beiBedarf } from "./bei-bedarf";
import { registerRevalidator } from "./revalidate.svelte";

import { loadPersisted, persist } from "./persistent-summary.svelte";

export interface LightningStrike {
  dist: number;
  ts: number;
}

// Spiegelt internal/lightning.Status. Siehe WeatherLightning in
// weather-summary.svelte.ts -- selbe Semantik.
export type LightningStatus = "off" | "connecting" | "connected";

export interface LightningSnapshot {
  count_30m: number;
  nearest_km: number | null;
  strikes: LightningStrike[];
  track_radius_km: number;
  alert_radius_km: number;
  alert_cooldown_min: number;
  home_lat?: number;
  home_lon?: number;
  status: LightningStatus;
}

const STORAGE_KEY = "lightning";

const _state = new SvelteMap<string, LightningSnapshot>();
let _started = false;

async function refresh(): Promise<void> {
  try {
    const r = await fetch("/v2-api/lightning", { credentials: "include" });
    if (!r.ok) return;
    const snap = (await r.json()) as LightningSnapshot;
    _state.set("current", snap);
    persist(STORAGE_KEY, snap);
  } catch {
    // ignore
  }
}

const _bedarf = beiBedarf({ hole: refresh, takt: 30_000 });

export function startLightningSummary(): void {
  if (_started) return;
  _started = true;
  registerRevalidator(() => {
    if (_bedarf.aktiv()) void refresh();
  });
  const cached = loadPersisted<LightningSnapshot>(STORAGE_KEY);
  if (cached) _state.set("current", cached);
}

// Anmelden, solange die Seite offen ist; der Rückgabewert meldet wieder ab.
// In Svelte: $effect(() => { if (zuSehen()) return beobachteLightning(); }).
export function beobachteLightning(): () => void {
  return untrack(() => {
    startLightningSummary();
    return _bedarf.beobachte();
  });
}

export function stopLightningSummary(): void {
  _started = false;
  _bedarf.beende();
  _state.clear();
}

export function getLightningSummary(): LightningSnapshot | undefined {
  return _state.get("current");
}

export async function refreshLightningSummary(): Promise<void> {
  await refresh();
}
